import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
//css
import { Table } from "reactstrap";
import "./styled.css";
//redux
import { connect } from "react-redux";
//components
import Pagination from "../../../components/pagination";
import Podium from "./podium";
import UserPoints from "./userPoints";
// images 
import TopPodium1 from "../../../assets/images/ntt/ranking/toppodium1.png"
import TopPodium2 from "../../../assets/images/ntt/ranking/toppodium2.png"
import TopPodium3 from "../../../assets/images/ntt/ranking/toppodium3.png"
//service
import { getRanking, getRankingGuest } from "../../../utils/service/ranking";

function Ranking(props) {
  //paginação
  const [currentIndex, setCurrentIndex] = useState(1);
  const itemsPerPage = 30;
  //ranking
  const [ranking, setRanking] = useState([]);
  //dados do usuário
  const [idGuest, setIdGuest] = useState(null);
  const [nameGuest, setNameGuest] = useState(null);
  const [pointsGuest, setPointsGuest] = useState();
  //parametros de rota
  const [searchParams] = useSearchParams();
  // id do evento
  const idEvent = "bef4f42f-f289-442e-852d-c0f8dc13e53b";

  function getAllRanking() {
    getRanking(idEvent)
      .then((response) => {
        console.log("getAllRanking", response);
        if (response.count && response.count > 0) {
          setRanking(response.data);
        }
      })
      .catch((error) => console.log("erro", error));
  }

  //pegar o id do usuário
  useEffect(() => {
    getAllRanking();

    if (window.location.search) {
      const id = searchParams.get("idGuest");
      const name = searchParams.get("guest");
      setIdGuest(id);
      setNameGuest(name);
    }
  }, []);

  // consultar ranking do usuário pelo id coletado
  useEffect(() => {
    if (idGuest) {
      getRankingGuest(idEvent, idGuest)
        .then((res) => {
          console.log("getRankingGuest", res);

          if (res?.data?.totalPoints) {
            setPointsGuest(res.data.totalPoints);
          }
        })
        .catch((error) => console.log("error", error));
    }
  }, [idGuest]);

  return (
    <section className="section-ranking2">
      <div className="card-body-home">
        <div className="div-podios">
          <Podium ranking={ranking[1]} clasdPodium="podio2" order="2" imgPodium={TopPodium2} />

          <Podium ranking={ranking[0]} clasdPodium="podio1" order="1" imgPodium={TopPodium1} />

          <Podium ranking={ranking[2]} clasdPodium="podio3" order="3" imgPodium={TopPodium3} />
        </div>

        <UserPoints nameGuest={nameGuest} pointsGuest={pointsGuest} />

        <div className="table-responsive table-ranking">
          <Table className="table mb-0" style={{ backgroundColor: "white" }}>
            <thead className="table-light">
              <tr>
                <th>Posição</th>
                <th>Nome</th>
                <th>Pontos</th>
              </tr>
            </thead>
            <tbody>
              {ranking.map((e, i) => (
                <tr key={i}>
                  <td>{i + 1}</td>
                  <td>{e.name}</td>
                  <td>{e.totalPoints}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
        {/* <Pagination
        data={data}
        currentIndex={currentIndex}
        setCurrentIndex={setCurrentIndex}
        itemsPerPage={itemsPerPage}
      /> */}
      </div>
    </section>
  );
}

const mapStateToProps = function (state) {
  return { state: state };
};

export default connect(mapStateToProps)(Ranking);
